import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar to handle the images cropping workflow.
*/
@Component({
	selector: 'cropping-workflow',
	templateUrl: './cropping-workflow.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class CroppingWorkflowComponent extends BaseComponent {

	isImgVisible = false;
	readonly helpImg = 'images/gif/crop.gif';

	/**
	* Confirm cropping.
	*/
	confirm(): void {
		this.canvasSrv.dispatch('confirmCrop');
	}

}
